module.exports = __webpack_public_path__ + "media/conmex/herramientas-58f98746.png";